import styled from 'styled-components'
// themes
import colors from 'themes/colors'
// utils
import { darken } from 'polished'

export const RowsWrapper = styled.div<{ $mb: number }>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: margin-bottom 150ms ease;
  margin-bottom: ${({ $mb }) => `${$mb}px`};
`

export const AiButton = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  cursor: pointer;
  color: ${colors.blue500};

  svg {
    path {
      fill: ${colors.blue500};
    }
  }

  &:hover {
    color: ${darken(0.1, colors.blue500)};

    svg {
      path {
        fill: ${darken(0.1, colors.blue500)};
      }
    }
  }
`
